import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-5 flex flex-col gap-3" data-id="element-329">
      <div className="flex items-center gap-3" data-id="element-330">
        <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 border border-[#FFD700]/40 flex items-center justify-center text-[#FFD700] font-black text-xs flex-shrink-0" data-id="element-331">
          {initials}
        </div>
        <div data-id="element-332">
          <div className="text-[#FFD700] text-xs" data-id="element-333">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-334">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-335">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-336">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-337">
      <div className="max-w-5xl mx-auto" data-id="element-338">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-339">
          Lo que dicen los profes
          <span className="text-[#FFD700]" data-id="element-340"> que ya lo usan:</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-341">
          +500 profesores de Argentina ya tienen su MegaPack
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-342">
          <TestimonialCard initials="SM" stars={5} quote="Compré un domingo. El lunes tenía todo el año organizado." name="Sebastián M." location="Buenos Aires" level="Profesor de Teatro en Primaria" data-id="element-343" />
          <TestimonialCard initials="CR" stars={5} quote="Las rúbricas del Bono 3 me cambiaron todo. Evalúo con criterios claros en cada clase." name="Claudia R." location="Rosario" level="Profesora en Secundaria" data-id="element-344" />
          <TestimonialCard initials="DP" stars={5} quote="El Tomo 4 es único. Mis alumnos de 1ro trabajan con subtexto real desde el primer mes." name="Diego P." location="Córdoba" level="Tallerista de Teatro" data-id="element-345" />
          <TestimonialCard initials="FL" stars={5} quote="El sistema de niveles con criterios observables eliminó las preguntas de '¿cuándo paso al siguiente nivel?'. Ahora el alumno lo ve en la rúbrica." name="Fernando L." location="Tucumán" level="Profesor en Escuela y Taller" data-id="element-346" />
          <TestimonialCard initials="LP" stars={5} quote="Mi participación en la muestra final pasó del 40% al 90%. Solo aplicando las estrategias del Tomo 5." name="Laura P." location="Mendoza" level="Profesora de Teatro" data-id="element-347" />
          <TestimonialCard initials="VT" stars={5} quote="Entrego el programa de mano con el nombre de cada alumno y los templates del Bono 5. Los padres pensaron que era una producción profesional." name="Valeria T." location="Santa Fe" level="Tallerista de Teatro para Adultos" data-id="element-348" />
        </div>
      </div>
    </section>;
}